module.exports = __webpack_public_path__ + "img/fla.eeabc6fe.svg";